import * as audio from './kernel/audio.js';

export {
    init,
}

const sounds = [
    { name: 'ui-pack', url: new URL('../sounds/ui-pack.aac', import.meta.url) },
    { name: 'dial-up-modem', url: new URL('../sounds/Dial_up_modem_noises.aac', import.meta.url) },
    { name: 'foret', url: new URL('../sounds/Foret-fix.aac', import.meta.url) },
    { name: 'branches', url: new URL('../sounds/Branches.m4a', import.meta.url) },
    { name: 'pelle', url: new URL('../sounds/Pelle.m4a', import.meta.url) },
    { name: 'riviere', url: new URL('../sounds/Riviere.m4a', import.meta.url) },
    { name: 'autoroute', url: new URL('../sounds/Autoroute.m4a', import.meta.url) },
    { name: 'voiture-arrive', url: new URL('../sounds/Voiture_arriv.m4a', import.meta.url) },
    { name: 'radio-loin', url: new URL('../sounds/Radio_loin.m4a', import.meta.url) },
    { name: 'course-mort', url: new URL('../sounds/Course_mort.m4a', import.meta.url) },
    { name: 'course-mort-rev', url: new URL('../sounds/Course_mort_reverse.m4a', import.meta.url) },
    { name: 'attente-cigarette', url: new URL('../sounds/Attente_cig.m4a', import.meta.url) },
    { name: 'attente-vaporette', url: new URL('../sounds/Attente_vapor.m4a', import.meta.url) },
    { name: 'voiture-entree', url: new URL('../sounds/Voiture_entree.m4a', import.meta.url) },
    { name: 'pas', url: new URL('../sounds/Pas.m4a', import.meta.url) },
    { name: 'fin-jazz', url: new URL('../sounds/Fin1_gauche_jazz.m4a', import.meta.url) },
    { name: 'fin-electro', url: new URL('../sounds/Fin2_droite_electro.m4a', import.meta.url) }
];

function init() {
    setupMobileKeyboard();
    return loadSounds();
}

function loadSounds() {
    return Promise.all([
        ...sounds.map(sound => {
            return audio.buffers.load(sound.name, sound.url);
        }),
    ]).then(() => {
        if (DEVMODE) console.log('All sounds loaded');
    });
}

function setupMobileKeyboard() {
    // Trigger mobile keyboard on screen click
    const screenElement = document.querySelector('.screen');

    // Focus input on screen click, raising the keyboard
    screenElement.addEventListener('click', () => {
        const input = document.querySelector('.mobile-input');
        input.focus();
    });

    // Prevent hitting enter submitting the mobile form for input
    document.querySelector('form').addEventListener('keypress', e => e.preventDefault());
}